import { Timestamp, timestampDate } from '@bufbuild/protobuf/wkt';
import { queryOptions } from '@tanstack/react-query';
import { getReservoirDynamicInfo } from '~/pages/ReservoirDynamicInfo/api/resevoirDynamicInfo.api';
import { ReservoirDynamicInfoListModel } from '~/pages/ReservoirDynamicInfo/models/ReservoirDynamicInfoListModel';

export const getReservoirDynamicInfoQuery = (
  resourceName: string,
  timestamp?: Timestamp,
) =>
  queryOptions({
    queryKey: [
      'reservoirDynamicInfo',
      resourceName,
      timestamp && timestampDate(timestamp),
    ],
    queryFn: async () => {
      const response = await getReservoirDynamicInfo(resourceName, timestamp);
      return new ReservoirDynamicInfoListModel(response);
    },
    refetchOnWindowFocus: false,
  });
